









































































































import {
  BForm, BButton, BFormCheckbox, BFormGroup, BFormInput, 
  BRow, BCol, BSpinner, BFormSelect, BModal, BCardText,
  BCardTitle, BNavItem, BFormSelectOption, BCard, 
  BFormDatepicker, BMedia
} from "bootstrap-vue";
import { Component, Vue } from "vue-property-decorator";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import { errorAlert, successAlert } from "@/libs/sweetAlerts/alerts";
import appSettings from "@/appSettings";
import { PaginatedList } from "@/api/models/common/paginatedList";
import { PtfBeneficiaireBeneficiaire } from "@/api/models/ptfBeneficiaire/Beneficiaire";
import { PtfBeneficiaireMeeting } from "@/api/models/ptfBeneficiaire/Meeting";
import AppTimeline from "@/@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@/@core/components/app-timeline/AppTimelineItem.vue";
import { PtfBeneficiaireMeetingGrouped } from "@/api/models/ptfBeneficiaire/MeetingGrouped";
import CreateMeetingDialog from "./CreateMeetingDialog.vue";

@Component({
  components: {
    BRow, BCol, BButton, BFormInput, BSpinner, BForm,
    BFormGroup, BFormCheckbox, BModal, ValidationProvider,
    ValidationObserver, BFormSelect, BCardText, BCardTitle,
    BNavItem, BFormSelectOption, BCard, BFormDatepicker,
    AppTimeline, AppTimelineItem, BMedia, CreateMeetingDialog
  },
})
export default class DetailsBeneficiaire extends Vue {
  tenantId = appSettings.getTenantId();
  tenantName = appSettings.getTenantName().toLowerCase();
  beneficiaire: PtfBeneficiaireBeneficiaire | null = null;
  mainLoading = false;
  loadingRdv = false;
  loadingSave = false;
  required = required;
  timeout: any = null;
  refreshIndex = 0
  isAddNewMeetingDialogActive = false

  dateDebut: string | null = this.getCurrentDate();
  dateFin: string | null = null

  listMeetings: PtfBeneficiaireMeetingGrouped[] = []

  async created() {
    await this.loadBeneficiaire()
  }
  getCurrentDate(): string {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  getHeure(dateTime: any) {
    var date = new Date(dateTime);
    return date.toLocaleTimeString('fr-FR', {hour: '2-digit', minute:'2-digit'}).replace(':', 'h');
  }

  getJour(dateTime: any) {
    var date = new Date(dateTime);
    return date.toLocaleString('fr-FR', { day: '2-digit' });
  }
  
  getWeekDay(dateTime: any) {
    var date = new Date(dateTime);
    var weekDay = date.toLocaleString('fr-FR', { weekday: 'long' })
    return weekDay[0].toUpperCase() + weekDay.slice(1)
  }

  getMois(dateTime: any) {
    var date = new Date(dateTime);
    return date.toLocaleString('fr-FR', { month: 'long' });
  }

  async loadBeneficiaire() {
    this.mainLoading = true;
    await this.$http.ptfBeneficiaire.beneficiaires
      .getBeneficiaireById(this.$route.params.id)
      .then((res: PtfBeneficiaireBeneficiaire) => {
        this.beneficiaire = res;
        this.mainLoading = false;
      });
  }

  async searchMeetings() {
    this.loadingRdv = true
    if(this.timeout) clearTimeout(this.timeout);
    this.timeout = setTimeout(async () => {
      await this.loadListMeetings({
        dateDebut: this.dateDebut,
        dateFin: this.dateFin,
        beneficiaireId: this.$route.params.id
      })
    }, 1000);
  }

  async loadListMeetings(params: any) {    
    await this.$http.ptfBeneficiaire.beneficiaires
      .listMeetingsByBeneficiaireId(
        params?.beneficiaireId,
        params?.dateDebut,
        params?.dateFin
      )
      .then((response: PtfBeneficiaireMeetingGrouped[]) => {
        this.listMeetings = response.map(group => ({
          ...group,
          allInitiallyNotified: group.meetings?.every(meeting => meeting.isUserNotified === true) ?? false,
          meetings: group.meetings?.map(meeting => ({
            ...meeting,
            initialNotified: meeting.isUserNotified
          }))
        }));
        this.loadingRdv = false
      }
    );
  }

  goToList() {
    this.$router.push({ name: "manage-beneficiaires" });
  }

  onMeetingCreated() {
    this.searchMeetings()
  }

  resetMeetingDialog() {
    // Called when dialog is closed
  }
}
